import { render, staticRenderFns } from "./PaginationSimple.vue?vue&type=template&id=08a2b9d6&scoped=true&"
import script from "./PaginationSimple.vue?vue&type=script&lang=js&"
export * from "./PaginationSimple.vue?vue&type=script&lang=js&"
import style0 from "./PaginationSimple.vue?vue&type=style&index=0&id=08a2b9d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a2b9d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
